import React, { useEffect, useState, useRef } from 'react';
import { Plus, Trash2, X, Check, Upload, Download, Eye } from 'lucide-react';
import { documentoService } from '../../services/api';
import toast from 'react-hot-toast';

const CATS = ['estatuto','ata','relatorio','contrato','certidao','outros'];

export default function AdminDocumentos() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ titulo:'', descricao:'', categoria:'ata', ano: new Date().getFullYear().toString() });
  const [arquivo, setArquivo] = useState<File|null>(null);
  const fileRef = useRef<HTMLInputElement>(null);

  const load = () => { setLoading(true); documentoService.listar().then(r=>setItems(Array.isArray(r.data)?r.data:r.data.documentos||[])).catch(()=>toast.error('Erro')).finally(()=>setLoading(false)); };
  useEffect(load,[]);
  const onChange = (e:any) => setForm(f=>({...f,[e.target.name]:e.target.value}));

  const salvar = async () => {
    if(!arquivo && !form.titulo){ toast.error('Selecione um arquivo'); return; }
    setSaving(true);
    try {
      const fd=new FormData(); Object.entries(form).forEach(([k,v])=>fd.append(k,v as string));
      if(arquivo) fd.append('arquivo',arquivo);
      await documentoService.criar(fd);
      toast.success('Documento enviado!'); setModal(false); setArquivo(null); setForm({titulo:'',descricao:'',categoria:'ata',ano:new Date().getFullYear().toString()}); load();
    } catch { toast.error('Erro ao enviar.'); } finally { setSaving(false); }
  };

  const deletar = async (id:string) => { if(!window.confirm('Excluir documento?')) return; try { await documentoService.deletar(id); toast.success('Excluído!'); load(); } catch { toast.error('Erro.'); } };

  return (
    <div>
      <div className="admin-page-header">
        <h1>Documentos</h1>
        <button className="btn btn-primary" onClick={()=>setModal(true)}><Plus size={17}/> Novo documento</button>
      </div>
      {loading ? <div className="loading-center"><div className="spinner"/></div> : (
        <div style={{overflowX:'auto'}}>
          <table className="admin-table">
            <thead><tr><th>Título</th><th>Categoria</th><th>Ano</th><th>Data</th><th>Ações</th></tr></thead>
            <tbody>
              {items.length===0&&<tr><td colSpan={5} style={{textAlign:'center',padding:32,color:'var(--texto-leve)'}}>Nenhum documento.</td></tr>}
              {items.map(item=>(
                <tr key={item._id}>
                  <td style={{fontWeight:600,fontSize:'0.9rem'}}>{item.titulo}</td>
                  <td><span className="badge badge-amarelo">{item.categoria}</span></td>
                  <td>{item.ano}</td>
                  <td style={{fontSize:'0.82rem',color:'var(--texto-leve)'}}>{new Date(item.criadoEm||item.updatedAt).toLocaleDateString('pt-BR')}</td>
                  <td><div className="actions">
                    {item.arquivoUrl&&<><a href={item.arquivoUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-sm"><Eye size={14}/></a><a href={item.arquivoUrl} download className="btn btn-outline btn-sm"><Download size={14}/></a></>}
                    <button className="btn btn-sm" style={{background:'#fee2e2',color:'#b91c1c',borderRadius:'var(--radius)'}} onClick={()=>deletar(item._id)}><Trash2 size={14}/></button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {modal&&(
        <div className="admin-modal-overlay" onClick={()=>setModal(false)}>
          <div className="admin-modal" onClick={e=>e.stopPropagation()}>
            <div className="admin-modal-header"><h3>Novo Documento</h3><button className="modal-close" onClick={()=>setModal(false)}><X size={20}/></button></div>
            <div className="admin-modal-body">
              <div className="form-group">
                <label className="form-label">Arquivo (PDF) *</label>
                <div className="img-upload-area" style={{height:100}} onClick={()=>fileRef.current?.click()}>
                  {arquivo?<div style={{display:'flex',alignItems:'center',gap:10,color:'var(--laranja)',fontWeight:600}}><Upload size={20}/>{arquivo.name}</div>:<div className="img-upload-placeholder"><Upload size={22}/><span>Clique para selecionar PDF</span></div>}
                </div>
                <input ref={fileRef} type="file" accept=".pdf,.doc,.docx" style={{display:'none'}} onChange={e=>{const f=e.target.files?.[0];if(f)setArquivo(f);}}/>
              </div>
              <div className="form-group"><label className="form-label">Título *</label><input name="titulo" value={form.titulo} onChange={onChange} className="form-control"/></div>
              <div className="form-row-2">
                <div className="form-group"><label className="form-label">Categoria</label><select name="categoria" value={form.categoria} onChange={onChange} className="form-control">{CATS.map(c=><option key={c} value={c}>{c}</option>)}</select></div>
                <div className="form-group"><label className="form-label">Ano</label><input name="ano" value={form.ano} onChange={onChange} className="form-control" type="number" min="2000" max="2100"/></div>
              </div>
              <div className="form-group"><label className="form-label">Descrição</label><textarea name="descricao" value={form.descricao} onChange={onChange} className="form-control" rows={3}/></div>
            </div>
            <div className="admin-modal-footer">
              <button className="btn btn-outline" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={saving}>{saving?'Enviando…':<><Check size={16}/> Enviar</>}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
